var _rect, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmarksThumbnailGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#D3D6DA",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item-2",
    d: "M101 78V91C101 96.5228 96.5228 101 91 101H28.5C28.5 97.8 33 91 38.45 88.5C44.315 85 54.63 87.5 68.085 88.5C78.849 89.3 93.41 81.8333 101 78Z",
    fill: "#B5BBC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item-2",
    d: "M1 20L1 11C1 5.47715 5.47715 1 11 1L84 1.00001C84 4.20001 67.3283 8.74579 64.5 9.5C57 11.5 47.37 10.5 33.915 9.5C23.151 8.7 8.59 16.1667 1 20Z",
    fill: "#B5BBC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item",
    d: "M1 82V91C1 96.5228 5.47715 101 11 101H92C92 97.8 88.6333 94 86.95 92.5C78.365 89 74.73 91.5 55.035 92.5C39.279 93.3 12.11 85.8333 1 82Z",
    fill: "#A0A7B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item",
    d: "M101 15L101 11C101 5.47715 96.5228 1 91 0.999999L13 0.999991C13.5 4 13.3667 2.99999 15.05 4.49999C23.635 7.99999 27.27 5.49999 46.965 4.5C62.721 3.7 89.89 11.1667 101 15Z",
    fill: "#A0A7B0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5787,
    cy: 50.8554,
    rx: 14.4804,
    ry: 14.4575,
    transform: "rotate(90 25.5787 50.8554)",
    fill: "#505862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9436 75.0238C79.8755 75.0238 76.5757 71.7204 76.5757 67.6432C76.5757 63.5659 79.8755 60.2625 83.9436 60.2625C88.0118 60.2625 91.3115 63.5659 91.3115 67.6432C91.3115 71.7204 88.0117 75.0238 83.9436 75.0238Z",
    fill: "white",
    stroke: "#505862",
    strokeWidth: 1.37702
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6851 68.3742C85.5479 67.51 86.9407 67.4906 87.8271 68.3305L90.7905 71.1383C90.7905 71.1383 89.9453 72.3259 89.3086 73.0044C88.7052 73.6476 87.64 74.5256 87.64 74.5256L84.6851 71.5661C83.8051 70.6847 83.805 69.2556 84.6851 68.3742Z",
    fill: "#505862"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9436 25.3635C79.8755 25.3635 76.5757 28.6669 76.5757 32.7442C76.5757 36.8214 79.8755 40.1248 83.9436 40.1248C88.0118 40.1248 91.3115 36.8214 91.3115 32.7442C91.3115 28.6669 88.0118 25.3635 83.9436 25.3635Z",
    fill: "white",
    stroke: "#505862",
    strokeWidth: 1.37702
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6851 32.0132C85.5479 32.8774 86.9407 32.8967 87.8271 32.0568L90.7905 29.249C90.7905 29.249 89.9453 28.0615 89.3086 27.3829C88.7052 26.7397 87.64 25.8617 87.64 25.8617L84.6851 28.8212C83.8051 29.7026 83.805 31.1317 84.6851 32.0132Z",
    fill: "#505862"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.7583,
    cy: 50.3952,
    rx: 20.2738,
    ry: 20.2417,
    transform: "rotate(90 71.7583 50.3952)",
    fill: "#505862"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4494 37.6061C78.2055 41.8525 79.1094 46.4038 79.1094 51.0001L44.1648 51.0001L22.7138 51.0001L22.7142 50.9998L9.99998 43.6476C10.4423 41.586 11.0707 39.5637 11.8802 37.6061C13.6364 33.3597 16.2104 29.5013 19.4553 26.2513C22.7002 23.0012 26.5524 20.4231 30.7921 18.6642C35.0318 16.9053 39.5758 16 44.1648 16C48.7538 16 53.2978 16.9053 57.5375 18.6642C61.7772 20.4231 65.6294 23.0012 68.8743 26.2513C72.1193 29.5013 74.6932 33.3597 76.4494 37.6061Z",
    fill: "#67717E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7146 50.9999L9.99998 58.3523C10.4422 60.414 11.0707 62.4363 11.8802 64.3938C13.6364 68.6402 16.2104 72.4986 19.4553 75.7487C22.7002 78.9987 26.5524 81.5768 30.7921 83.3357C35.0318 85.0946 39.5758 85.9999 44.1648 85.9999C48.7538 85.9999 53.2978 85.0946 57.5375 83.3357C61.7772 81.5768 65.6294 78.9987 68.8743 75.7487C72.1193 72.4986 74.6932 68.6402 76.4494 64.3938C78.2055 60.1474 79.1094 55.5962 79.1094 50.9999L44.1648 50.9999L22.7146 50.9999Z",
    fill: "#818A98"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5709 50.9771C66.5711 51.017 66.5712 51.0569 66.5712 51.0969C66.5712 60.9452 62.3825 69.7847 55.7421 75.8244C64.3672 71.1244 70.2451 61.7806 70.2451 51.0211C70.2451 51.0064 70.2451 50.9918 70.2451 50.9771L66.5709 50.9771Z",
    fill: "#D5D8DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9358 50.9771C51.9359 51.0078 51.9359 51.0385 51.9359 51.0692C51.9359 58.6449 48.6842 65.4445 43.5291 70.0904C50.225 66.475 54.7881 59.2875 54.7881 51.011C54.7881 50.9997 54.7881 50.9884 54.7881 50.9771L51.9358 50.9771Z",
    fill: "#D5D8DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5882 50.7863C36.5883 50.8059 36.5883 50.8256 36.5883 50.8452C36.5883 55.6936 34.5491 60.0454 31.3163 63.0188C35.5154 60.7049 38.377 56.1049 38.377 50.8079C38.377 50.8007 38.377 50.7935 38.377 50.7863L36.5882 50.7863Z",
    fill: "#D5D8DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5709 50.9771C66.5711 50.9387 66.5712 50.9003 66.5712 50.8619C66.5712 41.3924 62.3825 32.8929 55.7421 27.0855C64.3673 31.6047 70.2451 40.5891 70.2451 50.9348C70.2451 50.9489 70.2451 50.963 70.2451 50.9771L66.5709 50.9771Z",
    fill: "#9DA4AF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9358 50.9771C51.9359 50.947 51.9359 50.9169 51.9359 50.8868C51.9359 43.4627 48.6842 36.7991 43.5291 32.2461C50.225 35.7891 54.7881 42.8329 54.7881 50.9439C54.7881 50.955 54.7881 50.9661 54.7881 50.9771L51.9358 50.9771Z",
    fill: "#9DA4AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5882 50.7863C36.5883 50.7675 36.5883 50.7488 36.5883 50.7301C36.5883 46.1089 34.5491 41.9612 31.3163 39.1272C35.5154 41.3325 38.377 45.7169 38.377 50.7656C38.377 50.7725 38.377 50.7794 38.377 50.7863L36.5882 50.7863Z",
    fill: "#9DA4AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0024,
    y: 67.4149,
    width: 15.2906,
    height: 15.2664,
    rx: 7.63319,
    transform: "rotate(90 42.0024 67.4149)",
    fill: "#E06351"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0024,
    y: 19.0578,
    width: 15.2906,
    height: 15.2664,
    rx: 7.63319,
    transform: "rotate(90 42.0024 19.0578)",
    fill: "#F1AE5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmarksThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LandmarksThumbnailGray.77d4a2760905333c2e2b5fbf636554f1.svg";